import { format, Months, setGlobalDateI18n } from 'fecha';

import { DataFormats } from '@skylab-shared/constants';
import { L10nBase } from '@skylab-shared/core';
import { isString } from '@skylab-shared/utils';

export class DateFormatBase {
    private subjectiveMonthNames!: Months;

    public constructor(
        l10n: L10nBase
    ) {
        this.subjectiveMonthNames = [
            l10n.instant('shared.scenes.filters.date-formats.subjective-month-names.january'),
            l10n.instant('shared.scenes.filters.date-formats.subjective-month-names.february'),
            l10n.instant('shared.scenes.filters.date-formats.subjective-month-names.march'),
            l10n.instant('shared.scenes.filters.date-formats.subjective-month-names.april'),
            l10n.instant('shared.scenes.filters.date-formats.subjective-month-names.may'),
            l10n.instant('shared.scenes.filters.date-formats.subjective-month-names.june'),
            l10n.instant('shared.scenes.filters.date-formats.subjective-month-names.july'),
            l10n.instant('shared.scenes.filters.date-formats.subjective-month-names.august'),
            l10n.instant('shared.scenes.filters.date-formats.subjective-month-names.september'),
            l10n.instant('shared.scenes.filters.date-formats.subjective-month-names.october'),
            l10n.instant('shared.scenes.filters.date-formats.subjective-month-names.november'),
            l10n.instant('shared.scenes.filters.date-formats.subjective-month-names.december')
        ];
    }

    public transform(value: Date | string | null | undefined, dateFormat?: string): string {
        if (!value) return '';

        const date = isString(value) ? new Date(value) : value;
        const defaultI18nDateNames = setGlobalDateI18n({});
        return this.isSubjectiveDateFormat(dateFormat)
            ? format(date, dateFormat, {...defaultI18nDateNames, monthNames: this.subjectiveMonthNames})
            : format(date, dateFormat);
    }

    private isSubjectiveDateFormat(format?: string): boolean {
        return [DataFormats.date.dayMonthYear, DataFormats.date.dayMonthYearDateTime].includes(format || '');
    }
}
